export default __webpack_public_path__ + "static/media/A4.81441a1d.mp3";